import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestCountryList = () => {
  const getUrl = '/user/country';

  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const resultCheck = () => {
  const getUrl = '/user/country/check';

  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestCountryList,
  resultCheck,
};
